export default __webpack_public_path__ + "static/media/advantages_3.e1fd1647.svg";